import { format } from 'date-fns'
import { Send } from 'lucide-react'

import { Banner } from '@/components/ui/banner'
import { listSentence } from '@/lib/formatters'
import { blockingChecks, type FillApplicationState, PickChannel } from '@/models/fillApplication'
import { SentRequoteButton } from './SentRequoteButton'

export function SentBanner({ orgId, state }: { orgId: string; state: FillApplicationState }) {
  const owner = state.emailRecipients.priceAndLink
  const pick = state.pendingChannelPick

  return (
    <Banner variant="info" icon={<Send />}>
      <div className="flex flex-col gap-3">
        <strong>Sent to carriers</strong>
        <ul className="flex flex-col gap-1">
          {state.priceEmails && owner && (
            <li>
              {owner.name || owner.email} gets a &quot;Your prices are in&quot; email as each carrier answers.
            </li>
          )}
          {!state.customerConfirmedAt && (
            <li>Corgi holds its price until the customer confirms their information.</li>
          )}
          {pick && (
            <li>
              Picked {listSentence(pick.vendors)} by {pick.channel === PickChannel.SMS ? 'text' : 'email'}
            </li>
          )}
          <li>
            {state.customerConfirmedAt ? (
              <>Confirmed {format(new Date(state.customerConfirmedAt), 'MMM d')}</>
            ) : (
              'Waiting for the customer to confirm'
            )}
          </li>
        </ul>
        {state.editedSinceSent && <p className="font-semibold">Changes since sent. Requote to send them.</p>}
        {state.application && (
          <div className="flex flex-wrap items-start gap-3">
            <SentRequoteButton
              orgId={orgId}
              applicationId={state.application.id}
              blocking={blockingChecks(state.checks)}
            />
          </div>
        )}
      </div>
    </Banner>
  )
}
